

// views
import View from '@views/terms'
export default View

// i18n
import { getServerSidePropsI18n, GetServerSidePropsContext } from "@core/i18n/pageService/getServerPropsI18n"
import { tDict } from "@core/i18n/useTranslate"

export const getServerSideProps = (context: GetServerSidePropsContext) => {
  return getServerSidePropsI18n(context,
    {
      config: {
        protected: false,
        appBar: {
          position: 'relative',
          // bgcolor: 'transparent',
        },
        plugins: {
          chat: false,
        },
        seo: {
          title: 'Terms of Service',
        },
      },
    });
};
